import { withTranslation } from "../../components/translation";
import NewPill from "../../components/NewPill";

export default withTranslation(NewPill);
